'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _reportHeader = require('../../reports/report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _shopify = require('../../shopify.svg');

var _shopify2 = _interopRequireDefault(_shopify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingStyle = {
  height: 255,
  width: '100%'
};

var shopifyLogoStyle = {
  height: '3em',
  width: 'auto',
  margin: '0 15px 0 0'
};

var emptyStyle = {};

var getShopifyIcon = function getShopifyIcon() {
  return _react2.default.createElement('img', {
    style: shopifyLogoStyle,
    src: _shopify2.default,
    alt: 'Shopify'
  });
};

var TopHeader = function TopHeader(_ref) {
  var isLoading = _ref.isLoading,
      name = _ref.name,
      createdBy = _ref.createdBy,
      headerInfo = _ref.headerInfo;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, color: 'pink', style: isLoading ? loadingStyle : emptyStyle },
    isLoading && _react2.default.createElement(
      _semanticUiReact.Dimmer,
      { active: true, inverted: true },
      _react2.default.createElement(_semanticUiReact.Loader, {
        center: true,
        active: true,
        content: 'loading campaign'
      })
    ),
    !isLoading && _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Message,
        { icon: true },
        _lodash2.default.isEqual(_lodash2.default.get(headerInfo, 'reportType'), 'Shopify') && getShopifyIcon(),
        !_lodash2.default.isEqual(_lodash2.default.get(headerInfo, 'reportType'), 'Shopify') && _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
        _react2.default.createElement(
          _semanticUiReact.Message.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            name
          ),
          'created by ',
          createdBy
        )
      ),
      _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
    )
  );
};

TopHeader.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string.isRequired,
  createdBy: _propTypes2.default.string.isRequired,
  headerInfo: _propTypes2.default.object.isRequired
};

exports.default = TopHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/components/top-header/index.js
// module id = 1073
// module chunks = 1